'use client';

import { MarketplacePage } from 'src/components/MarketplacePage';
import { Layout } from 'src/layout';
import { MarketplaceProps } from 'src/types/marketplace';

export function Marketplace({
  cards,
  currentCategory,
  categories,
}: MarketplaceProps) {
  return (
    <Layout>
      <MarketplacePage
        currentCategory={currentCategory}
        categories={categories}
        cards={cards}
      />
    </Layout>
  );
}
